import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loadAsset } from 'core/services/asset';
import { moduleRequest } from 'core/services/product';
import { IAsset } from 'types/app/asset';
import { LoadingState } from 'types/domain/base';
import { IKeyArray } from 'types/IKeyArray';

export interface IAssetReducer {
  [key: string]: IAsset;
}

const initialState = {};

const assetSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setAssets(state, action: PayloadAction<IKeyArray<IAsset>>) {
      Object.values(action.payload).forEach((asset: IAsset) => {
        state[asset.id] = state[asset.id] ? { ...asset, ...state[asset.id] } : asset;
      });
    },
    updateAsset(state, action: PayloadAction<Partial<IAsset>>) {
      state[action.payload.id] = { ...(state[action.payload.id] || {}), ...action.payload };
    },
    unloadAsset(state, action: PayloadAction<string>) {
      state[action.payload].loading = LoadingState.DEFAULT;
    },
  },
  extraReducers: builder => {
    builder.addCase('asset/load/pending', (state, action: any) => {
      state[action.meta.arg.id].loading = LoadingState.LOADING;
      state[action.meta.arg.id].attempts = (state[action.meta.arg.id].attempts || 0) + 1;
    });
    builder.addCase('asset/load/fulfilled', (state, action: any) => {
      state[action.meta.arg.id].loading = LoadingState.LOADED;
    });
    builder.addCase('asset/load/rejected', (state, action: any) => {
      state[action.meta.arg.id].loading = LoadingState.ERROR;
    });
    builder.addCase(moduleRequest.rejected, (state, action: any) => {
      if (!state[`module_${action.meta.arg.id}`]) state[`module_${action.meta.arg.id}`] = {};
      state[`module_${action.meta.arg.id}`].attempts = (state[`module_${action.meta.arg.id}`].attempts || 0) + 1;
    });
  },
});

export const { setAssets, updateAsset, unloadAsset } = assetSlice.actions;

export default assetSlice.reducer;
